import React from 'react';
import { Toaster } from 'react-hot-toast';

/**
 * AppToaster — the app's one toaster (spec §3.14): top-centre, a 24px-radius card with a hairline,
 * the float shadow, 14/500 text, at most 420px wide, on the toast layer (`--z-toast`, above
 * dialogs). Success and error icons use the status fills; success lasts 4s, an error 6s.
 *
 * It sits just under the desktop top bar, and just under the phone pill (`--toast-top`, set in
 * styles/ui.css from --shell-gap / --topbar-h / --shell-top-inset). Mount it once, in App.js,
 * in place of the inline <Toaster>:
 *
 *   import AppToaster from './components/AppToaster/AppToaster';
 *   ...  <I18nProvider><AppToaster /> …
 *
 * All copy reaches it through t(): pages call toast.success(t('…')) / toast.error(t('…')).
 */
function AppToaster() {
  return (
    <Toaster
      position="top-center"
      containerStyle={{ top: 'var(--toast-top)', zIndex: 'var(--z-toast)' }}
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--color-surface)',
          color: 'var(--color-text)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-tile)',
          boxShadow: 'var(--shadow-float)',
          fontFamily: 'var(--font-sans)',
          fontSize: '14px',
          fontWeight: 500,
          maxWidth: 420,
        },
        success: { iconTheme: { primary: 'var(--color-success-fill)', secondary: 'var(--color-surface)' } },
        error: { duration: 6000, iconTheme: { primary: 'var(--color-danger-fill)', secondary: 'var(--color-surface)' } },
      }}
    />
  );
}

export default AppToaster;
